/** Formula to calculate a progress bar percent */

export default function getProgressPercent(
  currentStep: number,
  totalSteps: number,
): number {
  return (currentStep / totalSteps) * 100;
}
